import ContactForm from "../../components/ContactForm";
import FinvisageVideo from "../../components/FinvisageVideo";
import Testimonials from "../../components/Testimonials";
import CorporateFaq from "../Corporates/CorporateFaq";
import CorporateHome from "../Corporates/CorporateHome";
import { testimonialsData } from "../../config/Constant";

const Nbfcs = ({data}) => {
    return (
      <div>
      <CorporateHome CorporateData={data.subSection[3]} />
      <CorporateFaq
        title={data.midSection[3].title}
        BanksQNA={data.midSection[3].QA}
      />
      <FinvisageVideo
        title={data.Nbfcs.title}
         videoId={data.Nbfcs.videoLink}
      />
     
      <ContactForm hide={true}
        // sendLogsToGA={sendLogsToGA}
        // sendLogsToGASignUp={sendLogsToGASignUpCorporate}
      />
        <Testimonials testimonials={[testimonialsData[4]]} />
    </div>
    );
  };
  
  export default Nbfcs;